export default __webpack_public_path__ + "static/media/education.1600d469.jfif";